gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia()
    mm.add("(min-width: 1024px)", () => {
        gsap.to(".overlap-box", {
            y: -window.innerHeight,
            marginBottom: -document.querySelector('.section-hero').scrollHeight,
            scrollTrigger: {
                trigger: ".section-hero",
                start: "top top",
                end: "bottom top",
                scrub: 1.5,
                markers: false,
                pin: true,
            }
        });       
    })

    mm.add("(max-width: 1023px)", () => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".section-hero",
                start: "center center",
                end: "bottom top",
                scrub: 1.5,
                markers: false,
                pin: true,
            }
        })
        tl.to('.section-hero__img-col', {y:-300, duration: 1})
        tl.to(".overlap-box", {
            y: -window.innerHeight,
            marginBottom: -window.innerHeight,
            onComplete: () => {
                ScrollTrigger.refresh();
            }
        }, '-=1');       
    })

    
